/**
 * Fechas contadas desde ahora, para las pantallas de staff.
 *
 * POR QUÉ NO MOSTRAR LA FECHA CRUDA. Quien abre estas pantallas está contestando
 * "¿cuándo pasó esto?" y una marca de tiempo obliga a hacer la cuenta a mano cada vez.
 * "hace 20 minutos" se lee de una; "2026-08-24T11:44:52Z" no.
 *
 * `ahora` se pasa por parámetro para que esto se pueda probar sin depender del reloj.
 */

export function haceCuanto(iso: string, ahora: Date = new Date()): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return '—';
  const min = Math.floor((ahora.getTime() - t) / 60_000);
  // Un reloj adelantado no debe producir "hace -3 minutos".
  if (min < 1) return 'recién';
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return h === 1 ? 'hace 1 hora' : `hace ${h} horas`;
  const d = Math.floor(h / 24);
  if (d < 30) return d === 1 ? 'ayer' : `hace ${d} días`;
  const m = Math.floor(d / 30);
  return m === 1 ? 'hace 1 mes' : `hace ${m} meses`;
}

/** Día y hora local, para las cabeceras donde sí hace falta el dato exacto. */
export function fechaYHora(iso: string): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return '—';
  // 24 h a propósito: "09:05 a.m." parte el renglón en dos en la columna de la hora, y
  // en un registro de actividad el sufijo no aporta nada.
  return new Date(t).toLocaleString('es-MX', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

/** Solo la hora local: dentro de un rato de trabajo el día ya está en la cabecera. */
export function soloHora(iso: string): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return '—';
  return new Date(t).toLocaleTimeString('es-MX', {
    hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

/** "40 min" / "1 h 20 min". Cero minutos es una sola acción, no un rato de trabajo. */
export function duracionLegible(min: number): string {
  if (min <= 0) return 'un momento';
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const r = min % 60;
  return r === 0 ? `${h} h` : `${h} h ${r} min`;
}
